import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FileTextOutlined } from '@ant-design/icons';

const icons = { FileTextOutlined };

// ==============================|| MENU ITEMS - GUARD REPORTS ||============================== //

const guardReports = {
    id: 'guard',
    title: <FormattedMessage id="guard" />,
    type: 'group',
    children: [
        {
            id: 'guard-reports',
            title: <FormattedMessage id="reports" />,
            type: 'item',
            url: '/guard-reports',
            icon: icons.FileTextOutlined
        }
    ]
};

export default guardReports;
